import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';

class TowerController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let property ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        property[keys[i]] = '';
        if(val === 'today') property[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        property[keys[i]] = [];
      } else if(keys[i] === TowerController.Staff) {
        property[keys[i]] = '~' + user + '~';
      } else if(fieldType.includes(Const.MultiSelect)) {
        property[keys[i]] = '';
        if(val !== '') property[keys[i]] = '~' + val.replace(',', '~') + '~';
      } else {
        property[keys[i]] = val;
      }
    }
    property.status = Const.Active;
    property.property_status = 1;
    property.available_date = property.available_date 
      ? property.available_date : DateUtil.dateToServerDateTime(new Date());
    return property;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'id' && keys[i] !== 'status'
        && keys[i] !== 'firstname' && keys[i] !== 'middlename' && keys[i] !== 'lastname'
        && keys[i] !== 'gender' && keys[i] !== 'dob' && keys[i] !== 'progress'
        && keys[i] !== 'company_name' && keys[i] !== 'anniversary' && keys[i] !== 'industry'
        && keys[i] !== 'responsible_person' && keys[i] !== 'source'
        && keys[i] !== 'enquiry_date' && keys[i] !== 'email_opt' && keys[i] !== 'sms_opt'
        && keys[i] !== 'phone' && keys[i] !== 'email' && keys[i] !== 'site'
        && keys[i] !== 'address'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && fields[keys[i]].status !== Const.Trash) {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default TowerController;